const tech_img = require("../../assets/img/tutorials/maraton/tech.png");
const secondary_tech_img = require("../../assets/img/tutorials/maraton/secondary-tech.png");
const func_img = require("../../assets/img/tutorials/maraton/func.png");
const secondary_func_img = require("../../assets/img/tutorials/maraton/secondary-func.png");

export const MaratonSteps = [
  {
    name: "Media Maratón de Madrid",
    title: "Descripción funcional",
    description: (
      <span>
        <p>
          El gemelo digital de la <b>Media Maratón de Madrid</b>, ofrece una
          visión en tiempo real sobre el estado de la carrera y la situación de
          los corredores. A través de la monitorización de los pasos de cada uno
          de los corredores por cada punto kilométrico, el gemelo digital ofrece
          estimaciones de ritmos y tiempos de llegada a los próximos puntos a
          nivel individual y de categoría.
        </p>
        <p>
          Además del análisis en tiempo real del evento, la plataforma permite
          consultar el transcurso del mismo una vez finalizado, realizando
          estimaciones de posición de los corredores en cada momento y
          permitiendo consultar los ritmos de los mismos.
        </p>
        <p>
          Por otro lado, durante la realización del evento se llegan a cabo la
          monitorización de aglomeraciones de personas en las inmediaciones del
          recorrido, permitiendo obtener una visual sobre los puntos críticos de
          acumulación de personas y un sistema de alertado para reforzar los
          medios de seguridad.
        </p>
      </span>
    ),
    secondarydescription: (
      <span>
        <p>Área de Gobierno de Cultura, Turismo y Deporte</p>
        <p>Área de Gobierno de Urbanismo, Medio Ambiente y Movilidad</p>
        <p>
          Área de Gobierno de Vicealcaldía, Portavoz, Seguridad y Emergencias
        </p>
      </span>
    ),
    mainimage: <img src={func_img} alt="main_func" />,
    secondaryimage: <img src={secondary_func_img} alt="sec_func" />,
  },
  {
    name: "Media Maratón de Madrid",
    title: "Descripción técnica",
    description: (
      <div>
        <span>
          Integraciones técnicas
          <ul>
            <li>
              <b>Integración de Cartografía 2D y 3D</b>: Permite una
              representación detallada del espacio urbano y la interpretación de
              patrones geoespaciales.
            </li>
            <li>
              <b>Incorporación de Datos de IoT</b>: Para el monitoreo y análisis
              en tiempo real del movimiento y comportamiento de las multitudes.
            </li>
            <li>
              Aplicación de algoritmos de <b>simulación avanzada</b> para
              predecir y visualizar la afluencia de personas en eventos
              públicos, optimizando la planificación y la seguridad.
            </li>
          </ul>
        </span>
        <span>
          Origen de Datos
          <ul>
            <li>
              <b>Datos sintetizados</b> a partir de sensores especializados en
              medir la afluencia y movimientos de personas, proporcionando
              información clave para la toma de decisiones estratégicas.
            </li>
            <li>
              <b>Recorrido oficial de Media Maratón de Madrid</b>, integrando
              los distintos puntos kilométricos y puntos de avituallamiento
              establecidos.
            </li>
            <li>
              <b>
                Información de corredores y ritmos de Media Maratón de Madrid
                2023
              </b>
              , así como categorías y clasificaciones.
            </li>
          </ul>
        </span>
      </div>
    ),
    mainimage: <img src={tech_img} alt="main_tech" />,
    secondaryimage: <img src={secondary_tech_img} alt="sec_tech" />,
  },
];
